import {useEffect} from "react";
import {Button, Alert} from "antd";
import React, {useState} from "react";
import {formatDate, formatDateTime, useIsMobile} from "../../../../../_common/function";
import {Avatar, Badge, Col, Image, List, Modal, Row, Typography} from "antd";
import VirtualList from "rc-virtual-list";
import EmptyData from "../../../../../../brand/component/emptyData/view";
import Loader from "../../../../../../brand/component/loader/view";
import {useGetHeaderPushNotificationLogByUserId} from "../../../function";
import {NotificationOutlined} from "@ant-design/icons";

const {Paragraph} = Typography;

const CONTAINER_HEIGHT = 400;

const PushNotificationListing_1 = (props) => {
    const {isHeader} = props
    const isMobile = useIsMobile();
    const [data, total, fetchPage, loading, loadError] = useGetHeaderPushNotificationLogByUserId();
    useEffect(() => { fetchPage(); }, []);

    const [selected, setSelected] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [currentData, setCurrentData] = useState({})
    const [updatedRead, setUpdatedRead] = useState([])

    const renderTinyMCEContent = (content) => {
        const cleanContent = (content || '')
            ?.replace(/<\/?body[^>]*>/gi, '')
            ?.replace(/<img /g, '<img onerror="this.style.display=\'none\'" ');
        return <div className={"tinyMceParagraph"} dangerouslySetInnerHTML={{__html: cleanContent}}/>
    };

    const selectItem = () => {
        setSelected({})
    }

    const loadingComponent = (
        <Col span={24} className={"text-center mb-6"}>
            <div className={"min-h-[400px]"}>
                <Loader/>
            </div>
        </Col>
    )

    const dateToday = formatDate(new Date(), true, "YYYY-MM-DD")

    const listComponent = (
        <List>
            {loadError && <Alert type="error" message="Could not load notifications" action={<Button onClick={() => fetchPage()}>Retry</Button>}/>}
            <VirtualList
                className={"cursor-pointer"}
                data={data}
                height={CONTAINER_HEIGHT}
                itemHeight={47}
                itemKey={"_id"}
            >
                {(item) => {
                    const time = item?.createdAt
                    const isToday = formatDate(time, true, "YYYY-MM-DD") === dateToday

                    return (
                        <div
                            className={"mb-2 text-start push-notification-card"}
                            role="button"
                            tabIndex={0}
                            onKeyDown={event => {if (event.key === "Enter" || event.key === " ") {event.preventDefault(); event.currentTarget.click();}}}
                            onClick={async () => {
                                if (isHeader) {
                                    setCurrentData(item)
                                    setModalOpen(true);
                                    // if (!item?.isRead && !updatedRead.includes(item?._id)) {
                                    //     const res = await updateUserPushNotificationReadStatus([item?._id], true)
                                    //     if (res?.updateUserPushNotificationReadStatus[0]?.isRead) {
                                    //         setUpdatedRead(prev => [...prev, res?.updateUserPushNotificationReadStatus[0]?._id])
                                    //         setUnreadPushNotificationCount(prev => prev - 1)
                                    //     }
                                    // } else if (item?.isPushNotificationUpdated && !updatedRead.includes(item?._id)) {
                                    //     const res = await updateUserPushNotificationReadStatus([item?._id], true)
                                    //     setUpdatedRead(prev => [...prev, res?.updateUserPushNotificationReadStatus[0]?._id])
                                    // }

                                    // setMessage({
                                    //     status: "open",
                                    //     title: item?.notification?.title,
                                    //     msg: <>
                                    //         {item?.notification?.body}
                                    //         <Image src={item?.notification?.image} preview={false}/>
                                    //     </>,
                                    //     icon: <Image src={item?.notification?.icon} preview={false}/>,
                                    //     onClose: async () => {
                                    //         const res = await updatePushNotificationLogReadStatus([item?._id], true)
                                    //         if (res?.updatePushNotificationLogReadStatus?.status === "success") {
                                    //             setUpdatedRead(prev => [...prev, item?._id])
                                    //             setUnreadPushNotificationCount(prev => prev - 1)
                                    //         }
                                    //     }
                                    // })
                                } else {
                                    selectItem()
                                }
                            }}
                        >
                            <Row wrap={false} gutter={[12, 0]}>
                                <Col flex={"none"}>
                                    <Badge
                                        offset={[-35, 5]}
                                        dot={!item?.isRead && !updatedRead.includes(item?._id)}
                                    >
                                        <Avatar
                                            size={40}
                                            src={item?.notification?.icon}
                                            shape={"circle"}
                                            icon={<NotificationOutlined/>}
                                        />
                                    </Badge>
                                </Col>
                                <Col flex={"auto"}>
                                    <Row wrap={false} align={"middle"}>
                                        <Col flex={"auto"}>
                                            <Row wrap={false}>
                                                {/*{!item?.isRead && !updatedRead.includes(item?._id) &&*/}
                                                {/*<Col span={2}>*/}
                                                {/*    <Badge dot offset={[-2, 2]}/>*/}
                                                {/*</Col>*/}
                                                {/*}*/}
                                                <Col span={!item?.isRead && !updatedRead.includes(item?._id) ? 22 : 24}>
                                                    <Paragraph ellipsis={{rows: 1}} className={"title"}>
                                                        {item?.notification?.title}
                                                    </Paragraph>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row wrap={false} align={"middle"}>
                                        <Col flex={"auto"}>
                                            <Paragraph ellipsis={{rows: 1}} className={"description"}>
                                                {item?.notification?.body}
                                            </Paragraph>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className={"text-end date-time"} style={{fontSize: "8px"}}>
                                            {formatDateTime(time, isToday ? "hh:mm A" : "DD/MM, hh:mm A")}
                                        </Col>
                                    </Row>
                                </Col>
                                {item?.notification?.image && (
                                    <Col flex={"none"} className={"push-notification-image"}>
                                        <Avatar src={item?.notification?.image} shape={"square"} size={55}/>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )
                }}
            </VirtualList>
            {data?.length < total && <Button loading={loading} onClick={() => fetchPage(data.length)}>Load more</Button>}
        </List>
    )

    const emptyComponent = (
        <div className={"mx-auto mt-6"}>
            <EmptyData/>
        </div>
    )

    return (
        <div id={"pushNotificationListing"}>
            {loadError && <Alert type="error" message="Could not load notifications" action={<Button onClick={() => fetchPage()}>Retry</Button>}/>}
            {loading ? loadingComponent : !!data?.length ? listComponent : emptyComponent}
            <Modal
                title={
                    <>
                        {currentData?.notification?.title}
                        <p className={"date-time"}>
                            {formatDateTime(currentData?.updatedAt || currentData?.createdAt, "MMMM Do YYYY, h:mm:ss a")}
                        </p>
                    </>
                }
                width={isMobile ? "90%" : "60%"}
                open={modalOpen}
                footer={null}
                onCancel={() => setModalOpen(false)}
                className={"push-notification-modal"}
                getContainer={() => document.querySelector("#layout-1")}
            >
                {currentData?.notification?.body && <p>{currentData?.notification?.body}</p>}
                {currentData?.notification?.image && (
                    <div className={"mt-4 text-center"}>
                        <Image src={currentData?.notification?.image} preview={false}/>
                    </div>
                )}
                {currentData?.longContent && (
                    <div className={"mt-4"}>{renderTinyMCEContent(currentData?.longContent)}</div>
                )}
            </Modal>
        </div>
    )
};

export default PushNotificationListing_1;